import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Title,
  title: 'Title',
  category: ComponentCategory.General,
};
